import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

// 子路由引入
import entrustRoutes from '@/router/business/agency/entrust'
import generateBiddingRoutes from '@/router/business/purchase/bidding-fun'
import generateInquiryRoutes from '@/router/business/purchase/inquiry-fun'
import generateCompeteRoutes from '@/router/business/purchase/compete-fun'
import generateNegotiationRoutes from '@/router/business/purchase/negotiation-fun'
import generateObjectionRoutes from '@/router/business/purchase/objection-fun'
import serviceFeeRoutes from '@/router/business/agency/service-fee'

/**
 * 招标采购代理下的路由
 */
export default {
  path: 'agency',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '招标采购（代理）',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [{ companyType: companyTypeDict.ENTERPRISE.value }],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
  roles: [
    platformFunctionModuleDict.AGENCY.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 代理委托
    entrustRoutes,
    // 代理采购
    {
      path: 'purchase',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '代理采购',
        icon: 'icon-side_agency_project',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.AGENCY.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 招标
        generateBiddingRoutes(
          'bidding',
          'Agency',
          '招标',
          [workbenchServiceDict.AGENCY.value],
          [platformFunctionModuleDict.AGENCY.right],
          {
            path: 'list',
            name: 'AgencyBiddingList',
            component: '/agency-views/entrust-purchase-project/bidding',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'AgencyBiddingList'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
            roles: [
              platformFunctionModuleDict.AGENCY.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },
          false
        ),
        // 询比
        generateInquiryRoutes(
          'inquiry',
          'Agency',
          '询比',
          [workbenchServiceDict.AGENCY.value],
          [platformFunctionModuleDict.AGENCY.right],
          {
            path: 'list',
            name: 'AgencyEntrustInquiryList',
            component: '/agency-views/entrust-purchase-project/inquiry',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'AgencyEntrustInquiryList'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
            roles: [
              platformFunctionModuleDict.AGENCY.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },
          false
        ),
        // 竞价
        generateCompeteRoutes(
          'compete',
          'Agency',
          '竞价',
          [workbenchServiceDict.AGENCY.value],
          [platformFunctionModuleDict.AGENCY.right],
          {
            path: 'list',
            name: 'AgencyEntrustCompeteList',
            component: '/agency-views/entrust-purchase-project/compete',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'AgencyEntrustCompeteList'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
            roles: [
              platformFunctionModuleDict.AGENCY.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },
          false
        ),
        // 谈判采购
        generateNegotiationRoutes(
          'negotiation',
          'Agency',
          '谈判',
          [workbenchServiceDict.AGENCY.value],
          [platformFunctionModuleDict.AGENCY.right],
          {
            path: 'list',
            name: 'AgencyEntrustNegotiationList',
            component: '/agency-views/entrust-purchase-project/negotiation',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'AgencyEntrustNegotiationList'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
            roles: [
              platformFunctionModuleDict.AGENCY.right,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },
          false
        )
      ]
    },
    // 异议处理
    generateObjectionRoutes(
      'objection',
      'Agency',
      '异议处理',
      [workbenchServiceDict.AGENCY.value],
      [platformFunctionModuleDict.AGENCY.right]
    ),
    // 代理服务费
    serviceFeeRoutes
  ]
}
